import { createSlice } from '@reduxjs/toolkit'
import { getAllRoundHistory, getMyBets, getPlayerStats, getTopBets } from '../slice-thunk/soccerCrashGame.thunk'

const initialState = {
  betHistoryData: [],
  resultData: [],
  currentRoundId: '',
  placedCrashBetId: [null, null],
  allRoundHistoryData: [],
  allRoundLoading: false,
  myBetsData: [],
  myBetsLoading: false,
  topBetsData: [],
  topBetsLoading: false,
  playerStats: null,
  crashBetHistoryData: [],
  isCashout: false,
  placingOrCashOutLoading: [false, false]
}

const {
  actions: {
    setPlacedBetsData,
    setResultData,
    setCurrentRoundId,
    setPlacedCrashBetId,
    setPlayerStats,
    addCrashBetHistoryData,
    setUserCashout,
    setPlacingOrCashoutLoading
  },
  reducer
} = createSlice({
  name: 'CC',
  initialState,
  reducers: {
    addCrashBetHistoryData: (state, action) => {
      return {
        ...state,
        crashBetHistoryData: [action.payload, ...state.crashBetHistoryData]
      }
    },
    setPlayerStats: (state, action) => {
      return {
        ...state,
        playerStats: action.payload
      }
    },
    setPlacedBetsData: (state, action) => {
      return {
        ...state,
        betHistoryData: action.payload
      }
    },
    setResultData: (state, action) => {
      return {
        ...state,
        resultData: action.payload
      }
    },
    setCurrentRoundId: (state, action) => {
      return {
        ...state,
        currentRoundId: action.payload
      }
    },
    setPlacedCrashBetId: (state, action) => {
      // // eslint-disable-next-line
      // debugger
      if (!action.payload?.reset) {
        const { id, betId } = action.payload
        const newPlacedCrashBetId = [...state.placedCrashBetId]
        newPlacedCrashBetId[id] = betId
        return {
          ...state,
          placedCrashBetId: newPlacedCrashBetId
        }
      } else {
        return {
          ...state,
          placedCrashBetId: initialState.placedCrashBetId
        }
      }
    },
    setUserCashout: (state, action) => {
      return {
        ...state,
        isCashout: action.payload
      }
    },
    setPlacingOrCashoutLoading: (state, action) => {
      if (action.payload?.index !== undefined && action.payload?.value !== undefined) {
        const index = action.payload?.index ?? 0
        const _loading = [...state.placingOrCashOutLoading]
        _loading[index] = action.payload.value
        return {
          ...state,
          placingOrCashOutLoading: _loading
        }
      }
      return state
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRoundHistory.fulfilled, (state, action) => {
        return {
          ...state,
          allRoundHistoryData: action.payload?.history,
          crashBetHistoryData: action.payload?.history || [],
          allRoundLoading: false
        }
      })
      .addCase(getMyBets.pending, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: true

        }
      })
      .addCase(getMyBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false

        }
      })
      .addCase(getPlayerStats.fulfilled, (state, action) => {
        return {
          ...state,
          playerStats: action.payload
        }
      })

      .addCase(getTopBets.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload,
          topBetsLoading: false
        }
      })
  }
})

export default reducer
export {
  setPlacedBetsData,
  setResultData,
  setCurrentRoundId,
  setPlacedCrashBetId,
  setPlayerStats,
  addCrashBetHistoryData,
  setUserCashout,
  setPlacingOrCashoutLoading
}
